import { Button, Grid2, Stack, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { IconPlus } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { plansList } from "../services/plans";
import PlansTableComponent from "../components/PlansTableComponent";
import PlansRegister from "../components/PlansRegister";
import PageHeader from "../components/PageHeader";

const Plans = () => {
  const [open, setOpen] = useState(false);
  // const [openFilters, setOpenFilters] = useState(false);

  // const onFilter = () => {
  //   setOpenFilters(false);
  //   refetch();
  // };

  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      name: string;
      status: boolean;
      value: string;
      recurrence: string;
      description?: string;
      installments?: string;
      fights: { fightId: string }[];
      free: boolean;
      paymentsType: string;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["plansList"],
    queryFn: async () => await plansList({}),
    initialData: [],
  });

  // const {
  //   data: dataIndicators,
  //   isLoading: isLoadingIndicators,
  //   isFetching: isFetchingIndicators,
  //   refetch: refetchIndicators,
  // }: {
  //   data: {
  //     allStudents: number;
  //     studentsByMonth: number;
  //     absentStudents: number;
  //     studentsPresents: number;
  //   };
  //   isLoading: boolean;
  //   isFetching: boolean;
  //   refetch: () => void;
  // } = useQuery({
  //   queryKey: ["studentsIndicators"],
  //   queryFn: async () =>
  //     await studentsIndicators({
  //       startDate: moment().startOf("month").toDate(),
  //       endDate: moment().endOf("month").toDate(),
  //     }),
  //   initialData: {
  //     allStudents: 0,
  //     studentsByMonth: 0,
  //     absentStudents: 0,
  //     studentsPresents: 0,
  //   },
  // });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Planos"
          subtitle="Informações gerais dos seus planos."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconPlus size={18} />
                <Typography variant="body2">Cadastrar plano</Typography>
              </Button>
            </Stack>
          }
        />

        {/* <Grid2 size={12}>
          <IndicatorsCard
            data={[
              {
                id: 1,
                title: "Total",
                value: dataIndicators?.allStudents,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
              {
                id: 2,
                title: "Novos no mês",
                value: dataIndicators?.studentsByMonth,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
              {
                id: 3,
                title: "Ausentes no mês",
                value: dataIndicators?.absentStudents,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
              {
                id: 1,
                title: "Check-in no mês",
                value: dataIndicators?.studentsPresents,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
            ]}
          />
        </Grid2> */}
        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={6}>
              {/* <IconButton
                  sx={{ backgroundColor: "primary.main", borderRadius: 2 }}
                  onClick={() => setOpenFilters(true)}
                >
                  <IconAdjustmentsHorizontal />
                </IconButton> */}
            </Grid2>
            <Grid2 size={12}>
              <PlansTableComponent data={data} refetch={() => refetchAll()} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      {open && (
        <PlansRegister
          open={open}
          onClose={() => setOpen(false)}
          refetch={() => refetchAll()}
        />
      )}
      {/* <StudentFilters
        open={openFilters}
        onClose={() => setOpenFilters(false)}
        onFilter={onFilter}
      /> */}
    </ContainerLoading>
  );
};

export default Plans;
